define('charts/unroll',["require", "exports", "../util/log"], function (require, exports, log) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    function init(chart) {
        // Handle unroll clicks
        var unrollLink = document.getElementById("unroll-link");
        var unrollCheckbox = document.getElementById("unroll-checkbox");
        if (unrollLink) {
            // Checkbox may default to true if back pressed
            if (unrollCheckbox.checked) {
                chart.setUnroll(true);
            }
            unrollLink.addEventListener("click", function () {
                unrollLink.blur();
                var unroll = !unrollCheckbox.checked;
                unrollCheckbox.checked = unroll;
                log.info("track " + (unroll ? "unroll" : "roll"));
                // Update chart
                chart.setUnroll(unroll);
                return false;
            });
        }
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/charts/unroll.js.map;
